import {
  Avatar,
  Card,
  Col,
  Descriptions,
  Divider,
  Progress,
  Row,
  Space,
  Tabs,
  Typography
} from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import DeleteModal from "../../../../commons/DeleteModal/DeleteModal";
import { Error } from "../../../../commons/Messages/Messages";
import { avatar01 } from "../../../../commons/PanelImagepath";
import EditProjects from "../../../../commons/Projects/EditProjects";
import { useTranslation } from "react-i18next";
import CustomerBranches from "../CustomerBranches";
import "./ProjectsListView.css";

const { Title, Text } = Typography;

const ClientsProjectsListView = ({ updateParent }) => {
  const { t } = useTranslation("dashboard");
  const { t: ta } = useTranslation("accounting");
  const params = useParams();
  const [data, setData] = useState([]);
  const [user, setUser] = useState({});
  const [pageNo, setPageNo] = useState(1);
  const [pageSize] = useState(100);

  const getData = async id => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/projects/client/${id}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      });
      setData(res.data);
    } catch (err) {
      Error(err.response?.data?.errorMessage || err.message);
    }
  };

  const getUser = async id => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/users/user/${id}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      });
      setUser(res.data);
    } catch (err) {
      Error(err.message);
    }
  };

  useEffect(() => {
    getData(params.id);
    getUser(params.id);
  }, [params.id]);

  return (
    <div className="client-profile-page">
      <Card>
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          <div className="client-profile-page__header">
            <Avatar size={96} src={user?.picture?.url || avatar01} />
            <div className="client-profile-page__info">
              <Title level={4}>
                {user?.firstName} {user?.lastName}
              </Title>
              <Text type="secondary">{user?.email}</Text>
              <div>{user?.description}</div>
            </div>
          </div>
          <Tabs defaultActiveKey="1">
            <Tabs.TabPane tab={t("About")} key="1">
              <Card>
                <Title level={5}>{t("Personal Details")}</Title>
                <Divider />
                <Descriptions bordered column={{ xs: 1, sm: 1, md: 2, lg: 3 }}>
                  <Descriptions.Item label={t("Name")}>
                    {user?.firstName} {user?.lastName}
                  </Descriptions.Item>
                  <Descriptions.Item label={t("Date of Birth")}>{user?.dob}</Descriptions.Item>
                  <Descriptions.Item label={t("Email ID")}>{user?.email}</Descriptions.Item>
                  <Descriptions.Item label={t("Phone")}>{user?.phone}</Descriptions.Item>
                  <Descriptions.Item label={t("Address")}>
                    {user?.city === undefined ||
                    user?.state === undefined ||
                    user?.zipCode === undefined ||
                    user?.country === undefined ? (
                      <></>
                    ) : (
                      `${user?.city} , ${user?.state} - ${user?.zipCode}, ${user?.country}.`
                    )}
                  </Descriptions.Item>
                </Descriptions>
              </Card>
            </Tabs.TabPane>
            <Tabs.TabPane tab={t("Projects")} key="2">
              <Row gutter={[16, 16]} className="mt-3">
                {data?.map((project, index) => (
                  <Col xs={24} sm={12} md={12} lg={8} key={index}>
                    <Link to={`/user/projects/${project?._id}`}>
                      <Card
                        className="client-profile-page__project"
                        title={project?.projectName}
                        extra={
                          <Space wrap>
                            <EditProjects data={project} updateParent={updateParent} />
                            <DeleteModal text="Projects" onClick={() => undefined} />
                          </Space>
                        }
                      >
                        <div className="p-3">
                          <Text>
                            <b>1</b> open task, <b>9</b> tasks completed
                          </Text>
                          <p>{project?.description}</p>
                          <Title level={5}>{t("Deadline")}:</Title>
                          <Text type="secondary">{project?.endDate}</Text>
                          <Title level={5}>{t("Project Leader")}:</Title>
                          <Avatar size={43} src={project?.projectLeader?.picture?.url} />
                          <Title level={5}>{t("Team")}:</Title>
                          <Space wrap>
                            {project?.team?.map((user, idx) => (
                              <Avatar key={idx} size={43} src={user?.picture?.url} />
                            ))}
                          </Space>
                          <Progress percent={50} status="active" />
                        </div>
                      </Card>
                    </Link>
                  </Col>
                ))}
              </Row>
            </Tabs.TabPane>
            <Tabs.TabPane
              tab={`${ta("Branches")}${
                (user?.branches || []).filter(b => b.active !== false).length
                  ? ` (${user.branches.filter(b => b.active !== false).length})`
                  : ""
              }`}
              key="3"
            >
              {user?._id ? <CustomerBranches
                  customer={user}
                  onChange={branches => setUser(prev => ({ ...prev, branches }))}
                /> : null}
            </Tabs.TabPane>
          </Tabs>
        </Space>
      </Card>
    </div>
  );
};

export default ClientsProjectsListView;
